import React from 'react';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';


export default class FisaClientWithChart extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        
}
    }


    rowColor = (r) =>{

        if(r ){
            let date = new Date()

            let s = r.split('.')
            if(s.length === 3){
                let dateScadent = new Date (s[2] , s[1], s[0])

                if(dateScadent < date ){
                    return 'red'
                }else{
                    return 'green'
                }
            }
    
          
        }
     
        
    }


    getTotalPlata = () =>{
        let list = this.props.listFacturi

        let listCounter = list.length

        let total = 0

        for(let i = 0 ; i< listCounter; i++){
            total += list[i].total
        }

        return total    
    }
     componentDidMount(){
    }
     render() { 
       return (
          <div>
               <Table style={{ width: '90%', margin: 'auto' }}>
                 <TableHead>
                     <TableRow style={{}}>

                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.document}
                         </TableCell>
                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.termen}
                         </TableCell>
                         <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                         {this.dictionary.financiarContabil.total}
                         </TableCell>
                       


                     </TableRow>
                 </TableHead>

                 <TableBody>
                     {this.props.listFacturi.map((l, idx) => {
                         return (
                             <TableRow  style={{ cursor: 'pointer'}} key={'factura' + idx}>
                                 <TableCell style={{ textAlign: 'center',color:this.rowColor(l.termen) }}>
                                     {l.document}
                                 </TableCell>

                                 <TableCell style={{ textAlign: 'center',color:this.rowColor(l.termen) }} >
                                     {l.termen}
                                 </TableCell>
                                 <TableCell style={{ textAlign: 'center',color:this.rowColor(l.termen) }} >
                                     {l.total} lei
                                 </TableCell>
                              

                             </TableRow>
                         )
                     })}
                     <TableRow  style={{ cursor: 'pointer'}} >
                                 <TableCell style={{ textAlign: 'center'}}>
                              
                                 </TableCell>

                                 <TableCell style={{ textAlign: 'center'}} >
                                   Total Cumulat
                                 </TableCell>
                                 <TableCell style={{ textAlign: 'center' }} >
                                    {this.getTotalPlata()} lei
                                 </TableCell>
                              

                             </TableRow>
                 </TableBody>
             </Table> 
         </div>
        );
       }
}